/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { BulkPromoteClassDto } from '../model/bulkPromoteClassDto';
// @ts-ignore
import { BulkPromotionResultDto } from '../model/bulkPromotionResultDto';
// @ts-ignore
import { ClassPromotionSuggestionsDto } from '../model/classPromotionSuggestionsDto';
// @ts-ignore
import { LearnerPromotionDto } from '../model/learnerPromotionDto';
// @ts-ignore
import { LearnerPromotionHistoryDto } from '../model/learnerPromotionHistoryDto';
// @ts-ignore
import { PromoteLearnerDto } from '../model/promoteLearnerDto';
// @ts-ignore
import { ReversePromotionDto } from '../model/reversePromotionDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class LearnerPromotionService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Promote a whole class to the next academic year
     * Every actively-enrolled learner’s outcome is computed automatically from their academic-year performance (CAPS pass rule) unless listed in &#x60;overrides&#x60;, which always wins. Learners who already have a decision for this year are skipped.
     * @endpoint post /learner-promotion/class/{classId}/bulk
     * @param classId 
     * @param bulkPromoteClassDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public learnerPromotionControllerBulkPromote(classId: number, bulkPromoteClassDto: BulkPromoteClassDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BulkPromotionResultDto>;
    public learnerPromotionControllerBulkPromote(classId: number, bulkPromoteClassDto: BulkPromoteClassDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BulkPromotionResultDto>>;
    public learnerPromotionControllerBulkPromote(classId: number, bulkPromoteClassDto: BulkPromoteClassDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BulkPromotionResultDto>>;
    public learnerPromotionControllerBulkPromote(classId: number, bulkPromoteClassDto: BulkPromoteClassDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling learnerPromotionControllerBulkPromote.');
        }
        if (bulkPromoteClassDto === null || bulkPromoteClassDto === undefined) {
            throw new Error('Required parameter bulkPromoteClassDto was null or undefined when calling learnerPromotionControllerBulkPromote.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/learner-promotion/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/bulk`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BulkPromotionResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: bulkPromoteClassDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List a learner’s grade-progression history
     * @endpoint get /learner-promotion/learner/{learnerId}
     * @param learnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public learnerPromotionControllerFindByLearner(learnerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<LearnerPromotionHistoryDto>>;
    public learnerPromotionControllerFindByLearner(learnerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<LearnerPromotionHistoryDto>>>;
    public learnerPromotionControllerFindByLearner(learnerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<LearnerPromotionHistoryDto>>>;
    public learnerPromotionControllerFindByLearner(learnerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (learnerId === null || learnerId === undefined) {
            throw new Error('Required parameter learnerId was null or undefined when calling learnerPromotionControllerFindByLearner.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/learner-promotion/learner/${this.configuration.encodeParam({name: "learnerId", value: learnerId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<LearnerPromotionHistoryDto>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Preview computed end-of-year outcomes for a class
     * Computes a suggested PROMOTED/RETAINED/GRADUATED outcome per actively-enrolled learner from their pooled academic-year marks (CAPS pass rule: every subject must reach Level 3 / 40%+). Read-only — nothing is created. Use this to pre-fill a review screen before calling bulk.
     * @endpoint get /learner-promotion/class/{classId}/suggestions
     * @param classId 
     * @param fromAcademicYearId Academic year being completed
     * @param toAcademicYearId Academic year being entered
     * @param toClassId Default destination class for learners the system suggests PROMOTED
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public learnerPromotionControllerGetSuggestions(classId: number, fromAcademicYearId: number, toAcademicYearId: number, toClassId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ClassPromotionSuggestionsDto>;
    public learnerPromotionControllerGetSuggestions(classId: number, fromAcademicYearId: number, toAcademicYearId: number, toClassId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ClassPromotionSuggestionsDto>>;
    public learnerPromotionControllerGetSuggestions(classId: number, fromAcademicYearId: number, toAcademicYearId: number, toClassId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ClassPromotionSuggestionsDto>>;
    public learnerPromotionControllerGetSuggestions(classId: number, fromAcademicYearId: number, toAcademicYearId: number, toClassId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (classId === null || classId === undefined) {
            throw new Error('Required parameter classId was null or undefined when calling learnerPromotionControllerGetSuggestions.');
        }
        if (fromAcademicYearId === null || fromAcademicYearId === undefined) {
            throw new Error('Required parameter fromAcademicYearId was null or undefined when calling learnerPromotionControllerGetSuggestions.');
        }
        if (toAcademicYearId === null || toAcademicYearId === undefined) {
            throw new Error('Required parameter toAcademicYearId was null or undefined when calling learnerPromotionControllerGetSuggestions.');
        }
        if (toClassId === null || toClassId === undefined) {
            throw new Error('Required parameter toClassId was null or undefined when calling learnerPromotionControllerGetSuggestions.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'fromAcademicYearId',
            <any>fromAcademicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'toAcademicYearId',
            <any>toAcademicYearId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'toClassId',
            <any>toClassId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/learner-promotion/class/${this.configuration.encodeParam({name: "classId", value: classId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/suggestions`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ClassPromotionSuggestionsDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Record one learner’s end-of-year outcome
     * PROMOTED/RETAINED open next year’s class enrolment; GRADUATED, TRANSFERRED and WITHDRAWN close the school membership. Prior marks and attendance are never modified.
     * @endpoint post /learner-promotion
     * @param promoteLearnerDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public learnerPromotionControllerPromote(promoteLearnerDto: PromoteLearnerDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<LearnerPromotionDto>;
    public learnerPromotionControllerPromote(promoteLearnerDto: PromoteLearnerDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<LearnerPromotionDto>>;
    public learnerPromotionControllerPromote(promoteLearnerDto: PromoteLearnerDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<LearnerPromotionDto>>;
    public learnerPromotionControllerPromote(promoteLearnerDto: PromoteLearnerDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (promoteLearnerDto === null || promoteLearnerDto === undefined) {
            throw new Error('Required parameter promoteLearnerDto was null or undefined when calling learnerPromotionControllerPromote.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/learner-promotion`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<LearnerPromotionDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: promoteLearnerDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reverse a promotion
     * Removes the class enrolment the promotion created. Refused once marks have been recorded against the destination class.
     * @endpoint patch /learner-promotion/{id}/reverse
     * @param id 
     * @param reversePromotionDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public learnerPromotionControllerReverse(id: number, reversePromotionDto: ReversePromotionDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<LearnerPromotionDto>;
    public learnerPromotionControllerReverse(id: number, reversePromotionDto: ReversePromotionDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<LearnerPromotionDto>>;
    public learnerPromotionControllerReverse(id: number, reversePromotionDto: ReversePromotionDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<LearnerPromotionDto>>;
    public learnerPromotionControllerReverse(id: number, reversePromotionDto: ReversePromotionDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling learnerPromotionControllerReverse.');
        }
        if (reversePromotionDto === null || reversePromotionDto === undefined) {
            throw new Error('Required parameter reversePromotionDto was null or undefined when calling learnerPromotionControllerReverse.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/learner-promotion/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/reverse`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<LearnerPromotionDto>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: reversePromotionDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
